import { FocusLayout } from 'components/layout/focus';
import { useSearchParams } from 'hooks/useSearchParams';
import PropTypes from 'prop-types';
import React from 'react';

export const ConnectSyncLayout = ({ children, activeNetwork, action, isOnlyAlly }) => {
  const [params] = useSearchParams();

  const getBackUrl = () => {
    if (params.returnTo === 'onboarding-integrations') {
      return `/networks/${activeNetwork?.slug}/welcome/onboarding/integrations`;
    }

    return !isOnlyAlly ? `/networks/${activeNetwork?.slug}/contacts` : `/settings/my-networks`;
  };

  return (
    <FocusLayout title="Connect your LinkedIn" backUrl={getBackUrl()} headerSx={{ opacity: action === 'sync' ? 1 : 0 }}>
      {children}
    </FocusLayout>
  );
};

ConnectSyncLayout.propTypes = {
  children: PropTypes.node.isRequired,
  activeNetwork: PropTypes.object.isRequired,
  action: PropTypes.string.isRequired,
  isOnlyAlly: PropTypes.bool.isRequired,
};
